import { MeetHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

const PutApprovedMeetData = (meetId, meetApprovalRequestId, meetObj, state, setState) => {
  if (state.isSaving !== true && !state.message) {
    const newState = {
      ...state,
      isSaving: true,
      isSaved: false,
      message: 'Saving...'
    };
    setState(newState);

    const meetIdForUrl = meetId ? encodeURIComponent(meetId) : 'NaN';
    const meetApprovalRequestIdForUrl = meetApprovalRequestId ? encodeURIComponent(meetApprovalRequestId) : 'NaN';
    const urlMeetApproved = `/Meet/${meetIdForUrl}/MeetApprovedRequest/${meetApprovalRequestIdForUrl}`;

    MeetHttpHelper(urlMeetApproved, 'PUT', meetObj)
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isObjLoaded: true,
            isSaving: false,
            isSaved: true,
            objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoaded: false,
          isSaving: false,
          isSaved: false,
          message: message
        });
      });
  }
};

export default PutApprovedMeetData;